import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyCNYap8Ol2n6yCyoWItY6V0kG-2IWpl0Tk",
  authDomain: "teddysladderwaitlist-68073.firebaseapp.com",
  projectId: "teddysladderwaitlist-68073",
  storageBucket: "teddysladderwaitlist-68073.appspot.com",
  messagingSenderId: "247939858916",
  appId: "1:247939858916:web:6cc025f0116dcd99b947f1",
  measurementId: "G-2MPV9T6Z9G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export {firestore};
export const db=getFirestore(app);
export const auth = getAuth(app);
